module.exports = __webpack_public_path__ + "fonts/VaIcons.2bc0279e.woff2";